import { render, staticRenderFns } from "./ScreenMorfologicaComCervical.vue?vue&type=template&id=0ce9059b&scoped=true&"
import script from "./ScreenMorfologicaComCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenMorfologicaComCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenMorfologicaComCervical.vue?vue&type=style&index=0&id=0ce9059b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce9059b",
  null
  
)

export default component.exports